import type { App } from 'vue'
import AppAutocomplete from './app-autocomplete.vue'
import AppDropdown from './app-dropdown.vue'
import AppDropdownItem from './app-dropdown-item.vue'
import AppEllipsisMenu from './app-ellipsis-menu.vue'

export default {
  install (app: App) {
    app.component('AppDropdown', AppDropdown)
    app.component('AppDropdownItem', AppDropdownItem)
    app.component('AppEllipsisMenu', AppEllipsisMenu)
    app.component('AppAutocomplete', AppAutocomplete)
  },
}

declare module 'vue' {
  export interface GlobalComponents {
    AppDropdown: typeof AppDropdown,
    AppDropdownItem: typeof AppDropdownItem,
    AppEllipsisMenu: typeof AppEllipsisMenu,
    AppAutocomplete: typeof AppAutocomplete,
  }
}
